<template>
	<template v-if="instashopData?.items.length">
		<Body :class="{'instashop-active': instashopData.instashopActive == true}" />
		<div class="instashop-modal" v-if="instashopData.instashopActive == true">	
			<div class="instashop-modal-main">
				<div class="fancybox-close instashop-modal-close" @click="instashopData.instashopActive = !instashopData.instashopActive"></div>
				<div class="instashop-modal-items">
					<PublishInstashopContent :instashopData="instashopData.items" :instashopItemIndex="instashopData.instashopItemIndex" mode="modal" />
				</div>
			</div>
		</div>
	</template>	
</template>

<script setup>
	const props = defineProps(['instashopData']);
</script>

<style lang="less" scoped>
	.instashop-modal{
		position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(30,8,49,0.3); padding: 135px; z-index: 100000; display: flex; align-items: center; justify-content: center;
		@media (max-width: @tp){padding: 0;}
	}
	.instashop-modal-main{
		position: relative; display: block; background: #fff; box-shadow: 0 30px 40px 0 rgba(85,41,122,0.28); width: 1480px;
		@media (max-width: @l){width: 1245px;}
		@media (max-width: @t){width: 930px; margin: auto;}
		@media (max-width: @tp){width: 100vw; height: 100vh; box-shadow: unset;}
	}
	.instashop-modal-items{
		padding: 28px 40px 40px;
		@media (max-width: @t){padding: 15px;}
		@media (max-width: @tp){padding: 0;}
	}
	.instashop-modal-close{
		position: absolute; top: 20px; right: 40px; cursor: pointer; width: 44px; height: 44px; border-radius: 2px; background: var(--primaryColor); display: flex; align-items: center; justify-content: center; cursor: pointer;
		&:before{.icon-close(); font: 16px/1 var(--fonti); color: #fff;}
		@media (max-width: @t){width: 40px; height: 40px; top: 14px; right: 15px;}
		@media (max-width: @tp){
			width: 56px; height: 56px; top: 0; right: 0;
			&:before{font-size: 18px;}
		}
	}
</style>
